<template>
  <div class="home">
    <div class="fr-container">
      <div class="fr-grid-row fr-mb-4w">
        <div class="fr-col">
          L'application AIDA vous permet de consulter ou modifier les informations relatives à votre compte académique. Elle vous permet également de réinitialiser votre mot de passe si vous l'avez oublié. 
        </div>
      </div>
      <div class="fr-grid-row fr-grid-row--gutters">
        <div class="fr-col">
          <VGouvFrCard 
            title="Identifiant ou mot de passe oublié"
            description="Je ne connais pas mon nom d'utilisateur ou mon mot de passe."
            href="#/oubli"
            :image="{
              src: require('../assets/locks.jpg')
              }"
            /> 
        </div>
        <div class="fr-col">
          <VGouvFrCard 
            title="Mon compte"
            description="Accéder ou modifier les informations relatives à mon compte."
            href="#/moncompte"
            :image="{
              src: require('../assets/login.jpg')
              }"
            /> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import VGouvFrCard from "@vue-gouv-fr/v-gouv-fr-card"

import "@gouvfr/dsfr/dist/dsfr/dsfr.min.css"
import "@gouvfr/dsfr/dist/dsfr/dsfr.nomodule.min.js"

export default {
  name: "home",
  components: {
    VGouvFrCard
  },
  props: {},
  data: () => ({}),
  methods: {},
};
</script>